__turbopack_context__.v({
  "PosterContainerLink": "M5_Dwa_PosterContainerLink",
});
